<template>
  <div>
    <slot v-if="authorized"></slot>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'authorized-link',
  props: ['tag'],
  data () {
    return {
      authorized: false
    }
  },
  methods: {
    ...mapActions(['loadUserPermissions']),
    ...mapMutations(['setUserPermissions']),
    checkPermission () {
      let tag = this.tag

      // Buscar a permissão de acordo com a tag
      let permissions = JSON.parse(window.localStorage.getItem('userPermissions')) || this.userPermissions
      let permission = permissions.filter(function (profilePermission) {
        if (profilePermission.tag === tag) {
          return profilePermission
        }
      })
      if (permission.length === 0) {
        // Caso a permissão não exista, o link é exibido
        this.authorized = true
      } else {
        // Caso a permissão exista, é exibido caso configurado (status: true)
        this.authorized = permission[0].status
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'currentUser'])
  },
  mounted () {
    this.checkPermission()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// AuthorizedLink.vue?246e31a0